import { mapState } from "vuex";
import _ from "lodash";

export const MetricMixin = {
  data() {
    return {
      usageInfo: {
        cpu: 0,
        memory: 0,
        disk: 0,
      },
    };
  },
  computed: {
    ...mapState({
      rdeMetrics: (state) => state.workspace.rdeMetrics,
    }),
  },
  watch: {
    rdeMetrics: {
      handler(rdeMetricsArr) {
        const num = (v) => (typeof v === "number" ? v : Number(v)) || 0;

        // Update usageInfo
        this.usageInfo = rdeMetricsArr.reduce(
          (acc, curr) => {
            const { cpu = 0, memory = 0, disk = 0 } = curr?.currentUsage ?? {};
            acc.cpu += num(cpu);
            acc.memory += num(memory);
            acc.disk += num(disk);
            return acc;
          },
          { cpu: 0, memory: 0, disk: 0 },
        );
      },
      deep: true,
    },
  },
  methods: {
    setMetric(id, currentUsage) {
      this.$store.dispatch("workspace/setRdeMetric", { id, currentUsage });
    },
    getCurrentUsage(metricData) {
      const cpuData = this.getLatestData(metricData?.cpu || {});
      const memoryData = this.getLatestData(metricData?.memory || {});
      const diskTotal = metricData?.["volumeUsed"];

      return {
        cpu: this.$helper.coreToMilicore(cpuData, 0) || 0,
        memory: this.$helper.byteToMebibyte(memoryData, 0) || 0,
        disk: diskTotal,
      };
    },
    getLatestData(lines) {
      if (_.isNull(lines) || _.isEmpty(lines)) {
        return 0;
      }

      const maxDate = _.maxBy(Object.keys(lines), (v) => new Date(v).getTime());
      return parseFloat(lines[maxDate] || 0);
    },
    metricFlatten(rawData) {
      return rawData?.map((metricData) => {
        const currentUsage = this.getCurrentUsage(metricData);
        return {
          id: metricData.id,
          currentUsage,
        };
      });
    },
  },
};
